function shopSlider() {
    $('.shop-slider').slick({
        fade: true,
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive : [
            {
                breakpoint:992,
                settings: {
                    arrows: false,
                },
            },
        ],
    });
}

function brandCarousel() {
    $('.brand-carousel').slick({
        dots: false,
        arrows: false,
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 9,
        slidesToScroll: 1,
        infinite: true,
        swipeToSlide: true,
        centerMode: true,
        focusOnSelect: true,
        responsive : [
            {
                breakpoint:1200,
                settings: {
                    slidesToShow: 7,
                },
            },
            {
                breakpoint:768,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
}

function productCarousel() {
    $('.product-carousel').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive : [
            {
                breakpoint:992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                },
            },
        ],
    });
}

export default {
    init() {
        shopSlider();
        brandCarousel();
        productCarousel();

        function sliderHeight() {

            var maxWidth = 1200;
            var maxWidthMobile = 768;
            var windowWidth = $(window).width();
            var carouselHeight = Math.round( windowWidth / 3 );

            if((maxWidthMobile < windowWidth) && (windowWidth < maxWidth)) {
                $('.shop-slider').removeClass('mobile-size');
                $('.shop-slider').height(carouselHeight);

            } else {
                $('.shop-slider').css('height', '');
            }

            if(maxWidthMobile < windowWidth) {
                $('.shop-slider').removeClass('shop-slider--mobile');
            } else {
                $('.shop-slider').addClass('shop-slider--mobile');
            }

        }

        sliderHeight();

        $(window).resize(function() {
            sliderHeight();
        });

    },

    finalize() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-shop-landing.js